/**
 * 商户入驻申请页（公开，无需登录）
 * 对应 F1 流程：提交主体信息 → 等运营审核 → 开子户 → ACTIVE
 */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, Button } from '../../components/ui'
import { api } from '../../api/client'

export function MerchantApply() {
  const nav = useNavigate()
  const [form, setForm] = useState({
    type: 'SELLER',
    companyName: '',
    creditCode: '',
    legalPerson: '',
    legalPersonId: '',
    taxNo: '',
    registerRegion: '330324',
    businessScope: '服装',
  })
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')
  const [success, setSuccess] = useState<{ merchantId: string; status: string } | null>(null)

  function set(k: string, v: string) {
    setForm((f) => ({ ...f, [k]: v }))
  }

  async function submit() {
    setLoading(true)
    setErr('')
    try {
      const r = await api.post<{ merchant_id: string; status: string }>('/merchants/apply', form)
      setSuccess({ merchantId: r.merchant_id, status: r.status })
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div style={{ maxWidth: 560, margin: '60px auto', padding: 24 }}>
        <Card title="✓ 入驻申请已提交">
          <div style={{ fontSize: 14, lineHeight: 2 }}>
            <div>主体ID：{success.merchantId}</div>
            <div>状态：<b style={{ color: '#854d0e' }}>{success.status}</b>（待平台审核）</div>
            <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid #eee' }} />
            <div style={{ color: '#666' }}>
              审核通过后，系统会自动为您开立银行虚拟子户，届时可登录开始使用。
            </div>
          </div>
          <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
            <Button onClick={() => nav('/login')}>返回登录</Button>
            <Button variant="default" onClick={() => location.reload()}>
              再申请一个
            </Button>
          </div>
        </Card>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 560, margin: '40px auto', padding: 24 }}>
      <h1 style={{ marginTop: 0 }}>商户入驻申请</h1>
      <p style={{ color: '#666' }}>填写主体信息，提交后等待平台审核（通常 1 个工作日）</p>

      <Card title="主体信息">
        <div style={{ display: 'grid', gap: 12 }}>
          <Field label="入驻身份">
            <select value={form.type} onChange={(e) => set('type', e.target.value)} style={inputStyle}>
              <option value="SELLER">电商商家（受托方/代销商）</option>
              <option value="FACTORY">工厂（委托方/货主）</option>
            </select>
          </Field>
          <Field label="企业名称">
            <input value={form.companyName} onChange={(e) => set('companyName', e.target.value)} style={inputStyle} placeholder="xx有限公司" />
          </Field>
          <Field label="统一社会信用代码">
            <input value={form.creditCode} onChange={(e) => set('creditCode', e.target.value)} style={inputStyle} placeholder="9133..." />
          </Field>
          <Field label="法定代表人">
            <input value={form.legalPerson} onChange={(e) => set('legalPerson', e.target.value)} style={inputStyle} />
          </Field>
          <Field label="法人身份证号">
            <input value={form.legalPersonId} onChange={(e) => set('legalPersonId', e.target.value)} style={inputStyle} placeholder="（脱敏存储）" />
          </Field>
          <Field label="纳税人识别号">
            <input value={form.taxNo} onChange={(e) => set('taxNo', e.target.value)} style={inputStyle} />
          </Field>
          <Field label="注册地（地区编码）">
            <input value={form.registerRegion} onChange={(e) => set('registerRegion', e.target.value)} style={inputStyle} />
          </Field>
          <Field label="经营类目（逗号分隔）">
            <input value={form.businessScope} onChange={(e) => set('businessScope', e.target.value)} style={inputStyle} />
          </Field>
        </div>

        {err && <div style={{ color: '#dc2626', marginTop: 12 }}>{err}</div>}

        <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
          <Button onClick={submit} disabled={loading}>
            {loading ? '提交中...' : '提交申请'}
          </Button>
          <Button variant="default" onClick={() => nav('/login')}>
            返回登录
          </Button>
        </div>
      </Card>

      <div style={{ marginTop: 16, padding: 12, background: '#fef9c3', borderRadius: 6, fontSize: 12, color: '#854d0e' }}>
        ⚠️ v1 demo：提交后会进入 PENDING 状态。用「运营-超管」登录 → 商户管理 → 审核通过，即可激活。
      </div>
    </div>
  )
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label style={{ display: 'block', fontSize: 13 }}>
      <div style={{ color: '#666', marginBottom: 4 }}>{label}</div>
      {children}
    </label>
  )
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid #d1d5db',
  borderRadius: 4,
  fontSize: 14,
  boxSizing: 'border-box',
}
